<template>
  <div class="page-content regular-grades">
    <div class="left-wrap">
      <div class="left-title">
        {{ $t('grades.subjects') }}
      </div>

      <div class="search-wrap">
        <div class="search-options-wrap">
          <div class="option-item">
            <div class="option-title">{{ $t('public.academicYear') }}</div>
            <a-select
              showSearch
              v-model="academic"
              style="width: 100%"
              :placeholder="$t('public.academicYear')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="handleSearch"
            >
              <a-select-option
                v-for="(item, index) in academicYearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('public.semester') }}</div>
            <a-select
              showSearch
              v-model="semester"
              style="width: 100%"
              :placeholder="$t('public.semester')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="handleSearch"
            >
              <a-select-option
                v-for="(item, index) in semesterList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <a-table
        v-for="(item, index) in dataSource"
        :key="index"
        size="middle"
        :rowKey="record => record.id"
        :loading="tableLoading"
        :dataSource="item.classes"
        :pagination="false"
        :rowClassName="
          record =>
            selectedClass === `${item.id}-${record.id}` ? 'selected-row' : ''
        "
        :customRow="
          record => {
            return {
              style: {
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  if (selectedClass === `${item.id}-${record.id}`) {
                    return
                  }
                  course = item.name
                  courseId = item.id
                  selectedClass = `${item.id}-${record.id}`
                  classInfo = record
                  classId = record.id
                  grade = record.grade
                }
              }
            }
          }
        "
      >
        <a-table-column :title="item.name" dataIndex="name"></a-table-column>

        <a-table-column title="" dataIndex="weeksSubmitCount" width="54px">
          <template slot-scope="weeksSubmitCount, record">
            {{ weeksSubmitCount || 0 }} / {{ record.weeksTotal || 0 }}
          </template>
        </a-table-column>
      </a-table>
    </div>

    <div class="right-wrap" v-if="!!classId">
      <div class="right-title">
        Regular Grades of {{ course }} in {{ classInfo.name }}
      </div>

      <switch-components
        :componentList="componentList"
        :active-component="activeComponent"
        @change-component="changeComponent"
      ></switch-components>

      <transition name="default" mode="out-in">
        <component
          :class-id="classId"
          :course-id="courseId"
          :academic="academic"
          :semester="semester"
          :grade="grade"
          :is="activeComponent"
          @submit-grades="submitGrades"
        ></component>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SwitchComponents from '@/components/SwitchComponents'
import TheRegularBasic from './TheRegularBasic'
import TheRegularQuiz from './TheRegularQuiz'
import TheRegularAdvisor from './TheRegularAdvisor'
import TheRegularAttendance from './TheRegularAttendance.vue'

export default {
  components: {
    SwitchComponents,
    TheRegularBasic,
    TheRegularQuiz,
    TheRegularAdvisor,
    TheRegularAttendance
  },

  data() {
    return {
      campusId: localStorage.getItem('campusId'),

      // 学年
      academic: undefined,
      // 学期
      semester: undefined,

      tableLoading: false,
      dataSource: [],

      course: undefined,
      courseId: undefined,
      grade: undefined,
      selectedClass: undefined,
      classId: undefined,
      classInfo: {},

      activeComponent: '',
      componentList: []
    }
  },

  computed: {
    ...mapGetters([
      'handleRightsList',
      'userId',
      'academicYearList',
      'semesterList'
    ])
  },

  watch: {
    course(val) {
      if (val === 'Class Advisor') {
        this.componentList = [
          {
            title: 'grades.basic',
            component: 'the-regular-basic',
            hidden: true
          },
          {
            title: 'grades.quiz',
            component: 'the-regular-quiz',
            hidden: true
          },
          {
            title: 'grades.attendance',
            component: 'the-regular-attendance',
            hidden: true
          },
          {
            title: 'grades.advisorComment',
            component: 'the-regular-advisor'
          }
        ]
        this.activeComponent = 'the-regular-advisor'
      } else {
        this.componentList = [
          {
            title: 'grades.basic',
            component: 'the-regular-basic'
          },
          {
            title: 'grades.quiz',
            component: 'the-regular-quiz'
          },
          {
            title: 'grades.attendance',
            component: 'the-regular-attendance',
            hidden: true
          },
          {
            title: 'grades.advisorComment',
            component: 'the-regular-advisor',
            hidden: true
          }
        ]
        this.activeComponent = 'the-regular-basic'
      }
    }
  },

  created() {
    this.selectYearSemester()
  },

  methods: {
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }

      // 默认考试
      if (month >= 9) {
        this.semester = this.semesterList[0].value
      } else if (month >= 6) {
        this.semester = this.semesterList[1].value
      } else if (month >= 3) {
        this.semester = this.semesterList[1].value
      } else {
        this.semester = this.semesterList[0].value
      }

      this.getDataSource()
    },

    handleSearch() {
      this.course = undefined
      this.courseId = undefined
      this.classInfo = {}
      this.classId = undefined
      this.selectedClass = undefined
      this.grade = undefined
      this.getDataSource()
    },

    submitGrades() {
      this.getDataSource()
    },

    // 班级
    getDataSource() {
      this.tableLoading = true
      this.$http(this.$api.GETCLASSBYCOURSEID, {
        userId: this.userId,
        campusId: this.campusId,
        academic: this.academic,
        term: this.semester
      }).then(r => {
        this.dataSource = r.data || []
        this.dataSource = this.dataSource.map(item => {
          if (!item.name) {
            return Object.assign(item, {
              id: 'advisor',
              name: 'Class Advisor',
              classes: item.advisor
            })
          } else {
            return item
          }
        })
        this.tableLoading = false
        if (this.dataSource.length > 0) {
          if (this.classId) {
            let haveClass = false

            for (let index = 0; index < this.dataSource.length; index++) {
              if (
                this.dataSource[index].classes &&
                this.dataSource[index].classes.length > 0
              ) {
                for (const item of this.dataSource[index].classes) {
                  if (item.id === this.classId) {
                    haveClass = true
                  }
                }
              }
            }

            if (!haveClass) {
              for (let index = 0; index < this.dataSource.length; index++) {
                if (
                  this.dataSource[index].classes &&
                  this.dataSource[index].classes.length > 0
                ) {
                  this.course = this.dataSource[index].name
                  this.courseId = this.dataSource[index].id
                  this.classInfo = this.dataSource[index].classes[0]
                  this.classId = this.dataSource[index].classes[0].id
                  this.selectedClass = `${this.dataSource[index].id}-${
                    this.dataSource[index].classes[0].id
                  }`
                  this.grade = this.dataSource[index].classes[0].grade

                  break
                }
              }
            }
          } else {
            for (let index = 0; index < this.dataSource.length; index++) {
              if (
                this.dataSource[index].classes &&
                this.dataSource[index].classes.length > 0
              ) {
                this.course = this.dataSource[index].name
                this.courseId = this.dataSource[index].id
                this.classInfo = this.dataSource[index].classes[0]
                this.classId = this.dataSource[index].classes[0].id
                this.selectedClass = `${this.dataSource[index].id}-${
                  this.dataSource[index].classes[0].id
                }`
                this.grade = this.dataSource[index].classes[0].grade

                break
              }
            }
          }
        } else {
          this.course = undefined
          this.courseId = undefined
          this.classInfo = {}
          this.classId = undefined
          this.selectedClass = undefined
          this.grade = undefined
        }
      })
    },

    // 改变路由
    changeComponent(component) {
      // 同一组件，生命周期没有created
      this.activeComponent = component
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.regular-grades {
  padding: 0;
  min-height: calc(~'100% - @{pageHeaderHeight}');
  display: flex;
  @leftWidth: 230px;
  .left-wrap {
    padding: 15px 10px;
    margin-bottom: -30px;
    width: @leftWidth;
    border-right: 1px solid @lineColor;
    height: calc(100vh - 150px);
    overflow-y: scroll;
    overflow-x: hidden;
    .left-title {
      font-size: @titleFontSize;
      font-weight: bold;
      margin-bottom: 15px;
      margin-left: 5px;
    }
  }

  .left-wrap::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

    height: 1px;
  }

  .left-wrap::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/

    border-radius: 10px;

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    background: #d3d3d3;
  }

  .left-wrap::-webkit-scrollbar-track {
    /*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    border-radius: 10px;

    background: #ededed;
  }
  .right-wrap {
    margin-bottom: -30px;
    width: calc(~'100% - @{leftWidth}');
    .right-title {
      font-size: @titleFontSize;
      padding: 15px 15px 0;
      font-weight: bold;
      line-height: 30px;
      background-color: @backColor;
    }
  }
}
</style>

<style lang="less">
@import '../../style/variable.less';

.regular-grades {
  .subject-font {
    font-size: @titleFontSize;
  }
  .selected-row {
    background-color: @selectBackColor;
    &:hover:not(.ant-table-expanded-row) > td {
      background-color: @selectBackColor;
    }
  }
}
</style>
